import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { liveTasks, LiveTask } from '../data/tasks';
const VISIBLE = 3;
export function LiveTaskFeed() {
  const reduce = useReducedMotion();
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    if (reduce) return;
    const id = window.setInterval(() => setOffset(o => (o + 1) % liveTasks.length), 2800);
    return () => window.clearInterval(id);
  }, [reduce]);
  const visible: LiveTask[] = Array.from({
    length: VISIBLE
  }, (_, i) => {
    const index = (offset - i + liveTasks.length * 2) % liveTasks.length;
    return liveTasks[index];
  });
  return <div className="rounded-2xl border border-line bg-surface p-1.5 shadow-[0_24px_48px_-20px_rgba(0,0,0,0.25)]" data-id="element-193" data-mp="2fjssfi98adjl">
      <div className="flex items-center justify-between px-3 pb-2 pt-2 font-mono text-xs" data-id="element-194" data-mp="3393k8a8loxll">
        <span className="flex items-center gap-2" data-id="element-195" data-mp="380vdisj55hff">
          <span className="relative flex h-2 w-2" data-id="element-196" data-mp="381obb404gwlf">
            {!reduce && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent opacity-60" data-id="element-197" data-mp="8omxiwiu7ejk" />}
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent" data-id="element-198" data-mp="4p4ek6aktdjd" />
          </span>
          incoming
        </span>
        <span className="text-muted" data-id="element-199" data-mp="ihat5ny2zcgp">2,318 open</span>
      </div>

      <ul className="flex flex-col gap-1" aria-live="polite" data-id="element-200" data-mp="dnpvxy4bamik">
        <AnimatePresence initial={false} mode="popLayout" data-id="element-201" data-mp="sd5mpe3uery9">
          {visible.map((task, i) => <motion.li key={task.id} layout initial={{
          opacity: 0,
          y: -14,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.97
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className={`grid grid-cols-[auto_1fr_auto] items-center gap-3 rounded-xl px-3 py-2.5 transition-colors duration-200 ${i === 0 ? 'bg-accent-soft' : 'bg-canvas/60'}`} data-id="element-202" data-mp="neu9ctec9zba" data-mpi={i}>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-line bg-surface font-mono text-[11px] font-medium" data-id="element-203" data-mp="124iw2789zmzy">
                {task.countryCode}
              </span>
              <div className="min-w-0" data-id="element-204" data-mp="1bzu2815mblw3">
                <p className="truncate text-sm font-medium" data-id="element-205" data-mp="1g30g9uyz2hd4">{task.title}</p>
                <p className="mt-0.5 truncate font-mono text-[11px] text-muted" data-id="element-206" data-mp="1g0w3enj3i80p">
                  {task.city} · {task.category.toLowerCase()}
                </p>
              </div>
              <span className="font-display text-lg font-semibold tabular-nums" data-id="element-207" data-mp="1pzlm2iitfwi0">${task.payout}</span>
            </motion.li>)}
        </AnimatePresence>
      </ul>
    </div>;
}